import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import DashboardListView from "./dashboard-list.html";
import DashboardShowView from "./dashboard-show.html";


angular.module("dashboard", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('dashboard', {
                url: "/dashboard",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('dashboard.list', {
                url: "/list",
                controller: "dashboardListCtrl",
                template: DashboardListView
            })

           .state('dashboard.show', {
               url: "/show/:id",
               controller: "dashboardShowCtrl",
               template: DashboardShowView,
               data: { pageTitle: 'Evento actual' }
           })
        ;
    }])
;